import {ProfileService} from '../profile.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {createEffect, Actions, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {map, switchMap, tap, catchError, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as fromApp from './../../store/app.reducers';
import * as fromProfile from './profile.reducers';

import * as ProfileActions from './profile.actions';
import * as ErrorActions from '../../error/store/error.actions';
import * as UserActions from '../../user/store/user.actions';

import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Profile} from '../profile.model';
import {debounceTime, delay, take} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class ProfileEffects {

  getAuditsAutocomplete = createEffect(() => this.actions$.pipe(
    ofType(ProfileActions.GET_AUDITS_AUTOCOMPLETE),
    debounceTime(500),
    map(
      (data: {type: string, payload: { params: any } }) => {
        return {
          type: ProfileActions.GET_AUDITS,
          payload: data.payload
        };
      }
    )
  ), {dispatch: true}
  );

  getAudits = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_AUDITS),
      map(
        (data: {type: string, payload: { params: any } }) => {
          return data.payload;
        }
      ),
      switchMap(
        (data: {params: any}) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'auditList', box: 'list', value: false})
          );
          let saveAction = ProfileActions.SET_AUDITS;
          if (data.params.saveAction !== undefined) {
            saveAction = data.params.saveAction;
          }
          return this.profileService.getProfiles(data.params).pipe(
            mergeMap(
              (response: Profile[]) => {
                if (response.length === 1) {
                  // this.router.navigate(['audit', response[0].id]);
                }
                return [{
                  type: saveAction,
                  payload: response
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'auditList', box: 'list', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getAudit = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_AUDIT),
      map(
        (data: {type: string, payload: { id: number, params: any } }) => {
          return data.payload;
        }
      ),
      switchMap(
        (params: { id: number, params: any }) => {
          return this.profileService.getProfile(params.id, params.params).pipe(
            map(
              (response: Profile) => {
                return {
                  type: ProfileActions.SET_AUDIT,
                  payload: response
                };
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getAuditUsersRank = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_USERS_RANK),
      map(
        (data: {type: string, payload: { id: number, type: number, limit: number, offset: number, sortField: string, sortType: string, params: any } }) => {
          return data.payload;
        }
      ),
      switchMap(
        (params: { id: number, type: number, limit: number, offset: number, sortField: string, sortType: string, params: any }) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'audit', box: 'userRank', value: false})
          );
          return this.profileService.getProfileFollowerRank(params.id, params.type, params.limit, params.offset, params.sortField, params.sortType, params.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_USERS_RANK,
                  payload: response
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'audit', box: 'userRank', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getProfileDetail = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_PROFILE_DETAIL),
      map(
        (data: {type: string, payload: {id: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, params: any}) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'audit', box: 'detail', value: false})
          );
          return this.profileService.getProfileDetail(param.id, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_PROFILE_DETAIL,
                  payload: response
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'audit', box: 'detail', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getProfileAudienceTiktok = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_PROFILE_AUDIENCE_TIKTOK),
      map(
        (data: {type: string, payload: {id: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, params: any}) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'audit', box: 'audience_tiktok', value: false})
          );
          return this.profileService.getAudienceTiktok(param.id, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_PROFILE_AUDIENCE_TIKTOK,
                  payload: response
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'audit', box: 'audience_tiktok', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getProfileScore = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_PROFILE_SCORE),
      map(
        (data: {type: string, payload: {id: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, params: any}) => {
          return this.profileService.getProfileScore(param.id, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_PROFILE_SCORE,
                  payload: response
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getProfileProgress = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_PROFILE_PROGRESS),
      map(
        (data: {type: string, payload: {id: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, params: any}) => {
          return this.profileService.getProfileProgress(param.id, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_PROFILE_PROGRESS,
                  payload: response
                }, {
                  type: ProfileActions.GET_AUTOLOAD,
                  payload: {id: param.id, code: param.params.code}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );


  getProfileAutoload = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_AUTOLOAD),
      map(
        (data: {type: string, payload: {id: number, code: string}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, code: string}) => {
          return this.store.select('profile').pipe(
            take(1),
            delay(10000),
            map(
              (state: fromProfile.State) => {
                return {
                  state: state,
                  id: param.id,
                  code: param.code
                };
              }
            ),
          );
        }
      ),
      // switchMap(
      //   (param: {state: fromProfile.State, id: number}) => {
      //     return this.route.params.pipe(
      //       take(1),
      //       map(
      //         (params: Params) => {
      //           return {
      //             state: param.state,
      //             id: param.id,
      //             actualId: params.id
      //           };
      //         }
      //       )
      //     );
      //   }
      // ),
      mergeMap(
        (data: {state: fromProfile.State, id: number, actualId: number, code: string}) => {
          const actions = [];
          if (data.state.autoload) {
            if (data.state.loader.audit.mediaAnalyze && data.state.profileProgress.media.percent !== 100) {
              actions.push({
                type: ProfileActions.GET_MEDIA_ANALYZE,
                payload: {id: data.id, type: 1, params: { code: data.code }}
              });
              actions.push({
                type: ProfileActions.GET_FOLLOWER_ENGAGE,
                payload: {id: data.id, type: 1, params: { code: data.code }}
              });
            }

            if (data.state.audit !== null && data.state.audit.status === 1) {
              if (data.state.loader.audit.followerStat && data.state.profileProgress.follower.percent !== 100) {
                actions.push({
                  type: ProfileActions.GET_FOLLOWER_STAT,
                  payload: {id: data.id, type: 1, params: { code: data.code }}
                });
              }

              if (data.state.loader.audit.audienceStat && data.state.profileProgress.follower.percent !== 100) {
                actions.push({
                  type: ProfileActions.GET_AUDIENCE_STAT,
                  payload: {id: data.id, type: 1, params: { code: data.code }}
                });
              }

              if (data.state.loader.audit.mediaStat
                && (data.state.profileProgress.like.percent !== 100 || data.state.profileProgress.comment.percent !== 100)) {
                actions.push({
                  type: ProfileActions.GET_MEDIA_STAT,
                  payload: {id: data.id, params: { code: data.code }}
                });
              }

              if (data.state.loader.audit.engageIndicator
                && (data.state.profileProgress.like.percent !== 100 || data.state.profileProgress.comment.percent !== 100)) {
                actions.push({
                  type: ProfileActions.GET_MEDIA_STAT,
                  payload: {id: data.id, type: 1, params: { code: data.code }}
                });
              }
            }
          }

          if (actions.length > 0 || data.state.audit === null) {
            actions.push({
                type: ProfileActions.GET_PROFILE_PROGRESS,
                payload: {id: data.id, params: { code: data.code }}
            });
          }

          return actions;
        }
      )
    ), {dispatch: true}
  );

  getAudienceStat = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_AUDIENCE_STAT),
      map(
        (data: {type: string, payload: {id: number, type: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, type: number, params: any}) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'audit', box: 'audienceStat', value: false})

          );
          return this.profileService.getAudienceStat(param.id, param.type, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [
                  {
                    type: ProfileActions.SET_AUDIENCE_STAT,
                    payload: response
                  },
                  {
                    type: ProfileActions.SET_CHARTS_RELOAD,
                    payload: ProfileActions.SET_AUDIENCE_STAT
                  },
                  {
                    type: ProfileActions.SET_LOADER,
                    payload: {module: 'audit', box: 'audienceStat', value: true}
                  }
                ];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getAudienceInterest = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_AUDIENCE_INTEREST),
      map(
        (data: {type: string, payload: {id: number, type: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, type: number, params: any}) => {
          return this.profileService.getAudienceInterest(param.id, param.type, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_AUDIENCE_INTEREST,
                  payload: response
                }, {
                  type: ProfileActions.SET_CHARTS_RELOAD,
                  payload: ProfileActions.SET_AUDIENCE_INTEREST
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getAudienceLocation = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_AUDIENCE_LOCATION),
      map(
        (data: {type: string, payload: {id: number, type: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, type: number, params: any}) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'audit', box: 'audienceLocation', value: false})
          );
          return this.profileService.getAudienceLocation(param.id, param.type, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_AUDIENCE_LOCATION,
                  payload: response
                }, {
                  type: ProfileActions.SET_CHARTS_RELOAD,
                  payload: ProfileActions.SET_AUDIENCE_LOCATION
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'audit', box: 'audienceLocation', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getFollowerStat = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_FOLLOWER_STAT),
      map(
        (data: {type: string, payload: {id: number, type: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, type: number, params: any}) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'audit', box: 'followerStat', value: false})
          );
          return this.profileService.getFollowerStat(param.id, param.type, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_FOLLOWER_STAT,
                  payload: response
                }, {
                  type: ProfileActions.SET_CHARTS_RELOAD,
                  payload: ProfileActions.SET_FOLLOWER_STAT
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'audit', box: 'followerStat', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getFollowerEngage = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_FOLLOWER_ENGAGE),
      map(
        (data: {type: string, payload: {id: number, type: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, type: number, params: any}) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'audit', box: 'followerEngage', value: false})

          );
          return this.profileService.getFollowerEngage(param.id, param.type, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_FOLLOWER_ENGAGE,
                  payload: response
                }, {
                  type: ProfileActions.SET_CHARTS_RELOAD,
                  payload: ProfileActions.SET_FOLLOWER_ENGAGE
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'audit', box: 'followerEngage', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getFollowerEngageIndicator = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_FOLLOWER_ENGAGE_INDICATOR),
      map(
        (data: {type: string, payload: {id: number, type: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, type: number, params: any}) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'audit', box: 'engageIndicator', value: false})

          );
          return this.profileService.getFollowerEngageIndicator(param.id, param.type, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_FOLLOWER_ENGAGE_INDICATOR,
                  payload: response
                }, {
                  type: ProfileActions.SET_CHARTS_RELOAD,
                  payload: ProfileActions.SET_FOLLOWER_ENGAGE_INDICATOR
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'audit', box: 'engageIndicator', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                this.store.dispatch(
                  new ProfileActions.SetLoader({module: 'audit', box: 'engageIndicator', value: true })
                );
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getMediaStat = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_MEDIA_STAT),
      map(
        (data: {type: string, payload: {id: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, params: any}) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'audit', box: 'mediaStat', value: false})
          );
          return this.profileService.getMediaStat(param.id, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_MEDIA_STAT,
                  payload: response
                }, {
                  type: ProfileActions.SET_CHARTS_RELOAD,
                  payload: ProfileActions.SET_MEDIA_STAT
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'audit', box: 'mediaStat', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                this.store.dispatch(
                  new ProfileActions.SetLoader({module: 'audit', box: 'mediaStat', value: true})
                );
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getMediaAnalyze = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_MEDIA_ANALYZE),
      map(
        (data: {type: string, payload: {id: number, type: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, type: number, params: any}) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'audit', box: 'mediaAnalyze', value: false})
          );
          return this.profileService.getMediaAnalyze(param.id, param.type, param.params).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_MEDIA_ANALYZE,
                  payload: response
                }, {
                  type: ProfileActions.SET_CHARTS_RELOAD,
                  payload: ProfileActions.SET_MEDIA_ANALYZE
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'audit', box: 'mediaAnalyze', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getMediaCommentAnalyze = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_MEDIA_COMMENT_ANALYZE),
      map(
        (data: {type: string, payload: {id: number, type: number, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {id: number, type: number, params: any}) => {
          this.store.dispatch(
            new ProfileActions.SetLoader({module: 'audit', box: 'mediaCommentAnalyze', value: false})
          );
          return this.profileService.getMediaCommentAnalyze(param.id, param.type).pipe(
            mergeMap(
              (response: Profile) => {
                return [{
                  type: ProfileActions.SET_MEDIA_COMMENT_ANALYZE,
                  payload: response
                }, {
                  type: ProfileActions.SET_CHARTS_RELOAD,
                  payload: ProfileActions.SET_MEDIA_COMMENT_ANALYZE
                }, {
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'audit', box: 'mediaCommentAnalyze', value: true}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  addAudit = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.ADD_AUDIT),
      map(
        (data: {type: string, payload: { profile: string, channelType: string, redirect: boolean }}) => {
          return data.payload;
        }
      ),
      switchMap(
        (data: { profile: string, channelType: string, redirect: boolean }) => {
          return this.profileService.addProfile(data.profile, data.channelType, {}).pipe(
            mergeMap(
              (response: Profile) => {
                if (data.redirect) {
                  this.router.navigate(['/audit', response.id, data.channelType === 'instagram' ? 'waiting' : 'tiktok']);
                }
                this.notifierService.success('The report has been added!');
                const actions = [];
                actions.push({
                  type: ProfileActions.SET_LOADER,
                  payload: {module: 'auditAdd', box: 'add', value: true}
                });
                return actions;
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                this.store.dispatch(
                  new ProfileActions.SetLoader({module: 'auditAdd', box: 'add', value: true})
                );
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );


  addAuditCheck = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.ADD_AUDIT_CHECK),
      map(
        (data: {type: string, payload: {profile: string, channelType: string, redirect: boolean}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (data: {profile: string, channelType: string, redirect: boolean}) => {
          return this.profileService.addProfileCheck(data.profile, data.channelType).pipe(
            mergeMap(
              (response: any) => {
                const actions = [];
                this.store.dispatch(
                  new ProfileActions.SetLoader({module: 'auditAdd', box: 'add', value: false})
                );

                if (response.status === 1 && ((data.channelType === 'instagram' && response.stats.is_private === false) || (data.channelType === 'tiktok'))) {
                  actions.push({
                    type: ProfileActions.ADD_AUDIT,
                    payload: {
                      profile: data.profile,
                      channelType: data.channelType,
                      redirect: data.redirect
                    }
                  });
                } else if (response.status === 0 || response.status === 10) {
                  actions.push({
                    type: ProfileActions.GET_AUDIT_CHECK,
                    payload: {
                      uid: response.uid,
                      redirect: data.redirect
                    }
                  });
                } else if (response.status === -1 || (response.status === 1 && ((data.channelType === 'instagram' && response.stats.is_private === true) || (data.channelType === 'tiktok' && response.stats.tu !== undefined && response.stats.tu.isPrivate === true)))) {
                  this.notifierService.warning('Profile is not correct or private. You cannot generate an audit for this profile.');
                  actions.push({
                    type: ProfileActions.SET_LOADER,
                    payload: {module: 'auditAdd', box: 'add', value: true}
                  });
                }
                return actions;
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getAuditCheck = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.GET_AUDIT_CHECK),
      map(
        (data: {type: string, payload: {uid: string, redirect: boolean}}) => {
          return data.payload;
        }
      ),
      delay(3000),
      switchMap(
        (data: {uid: string, redirect: boolean}) => {
          return this.profileService.getProfileCheck(data.uid).pipe(
            mergeMap(
              (response: any) => {
                const actions = [];
                if (response.status === 1 && ((response.channel_type === 'instagram' && response.stats.is_private === false) || (response.channel_type === 'tiktok' && response.stats.tu !== undefined && response.stats.tu.isPrivate === false))) {
                  actions.push({
                    type: ProfileActions.ADD_AUDIT,
                    payload: {
                      profile: response.profile,
                      channelType: response.channel_type,
                      redirect: data.redirect
                    }
                  });
                } else if (response.status === 0) {
                  actions.push({
                    type: ProfileActions.GET_AUDIT_CHECK,
                    payload: {
                      uid: data.uid,
                      redirect: data.redirect
                    }
                  });
                } else if (response.status === -1 || (response.status === 1 && ((response.channel_type === 'instagram' && response.stats.is_private === true) || (response.channel_type === 'tiktok' && response.stats.tu !== undefined && response.stats.tu.isPrivate === false)))) {
                  this.notifierService.warning('Profile is not correct or private. You cannot generate an audit for this profile.');
                  actions.push({
                    type: ProfileActions.SET_LOADER,
                    payload: {module: 'auditAdd', box: 'add', value: true}
                  });
                }
                return actions;
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  updateProfileStatus = createEffect(() => this.actions$
    .pipe(
      ofType(ProfileActions.UPDATE_PROFILE_STATUS),
      map(
        (data: {type: string, payload: {profileId: number, status: number}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (param: {profileId: number, status: number}) => {
          return this.profileService.updateProfileStatus(param.profileId, param.status).pipe(
            mergeMap(
              (response: Profile) => {
                this.notifierService.success('Report status has been changed');
                return [{
                  type: ProfileActions.GET_AUDITS
                }, {
                  type: UserActions.GET_ACTUAL_USER
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                this.notifierService.warning('Credit your account to buy audit.');
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );


  constructor(
    private actions$: Actions,
    private profileService: ProfileService,
    private router: Router,
    private notifierService: ToastrService,
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,

) {}
}
